import React, { useState, useEffect, useRef, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import moment from "moment";
import debounce from "lodash.debounce";
import apiCall from "../../API/API";
import { toast, ToastContainer } from "react-toastify";
import { fetchUnpaidInstallment } from "../../Actions/adminActions";
import "react-toastify/dist/ReactToastify.css";

const UpcomingInstallment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { unpaidInstallment } = useSelector((state) => state.admin);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [filter, setFilter] = useState("none");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [search, setsearch] = useState({
    installment_amount: "",
    username: "",
    search: "",
    startDate: "",
    endDate: "",
  });

  // const [sortField, setSortField] = useState("");
  // const [sortOrder, setSortOrder] = useState("asc");

  const fetchInstallment = useCallback(
    debounce((params) => {
      dispatch(fetchUnpaidInstallment(params));
    }, 500),
    [dispatch]
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };

  const handlePagination = (page) => {
    // console.log("page",page)
    setCurrentPage(page);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setsearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
    fetchInstallment({
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
      ...(startDate && endDate ? { startDate, endDate } : {}),
    });
  };
  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const Addfilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };

    if (startDate) {
      queryParams.startDate = startDate;
    }
    if (endDate) {
      queryParams.endDate = endDate;
    }

    dispatch(fetchUnpaidInstallment(queryParams));
  };

  const resetFilter = () => {
    const queryParams = {
      page: "1",
      limit: 20,
    };
    dispatch(fetchUnpaidInstallment(queryParams));
    setsearch({
      installment_amount: "",
      username: "",
      search: "",
      startDate: "",
      endDate: "",
    });
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);
  };

  // const sortData = (data, field, order) => {
  //   return data?.slice().sort((a, b) => {
  //     if (field === "name") {
  //       const nameA = a.name.toUpperCase();
  //       const nameB = b.name.toUpperCase();
  //       if (order === "asc") return nameA > nameB ? 1 : -1;
  //       return nameA < nameB ? 1 : -1;
  //     } else if (field === "installment_Date") {
  //       const dateA = new Date(a.unpaidInstallment.installment_Date);
  //       const dateB = new Date(b.unpaidInstallment.installment_Date);
  //       return order === "asc" ? dateA - dateB : dateB - dateA;
  //     }
  //     return 0;
  //   });
  // };

  // const handleSort = (field) => {
  //   const newOrder = sortOrder === "asc" ? "desc" : "asc";
  //   setSortField(field);
  //   setSortOrder(newOrder);
  // };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    fetchInstallment(queryParams);
  }, [dispatch, currentPage, limitFilter, search, startDate, endDate]);

  useEffect(() => {
    setTotalPages(unpaidInstallment?.totalPages);
  }, [unpaidInstallment]);

  // const sortedData = sortData(installment?.data, sortField, sortOrder);

  //   const handleViewDetails = (sip_Id) => {
  //     navigate("/dashboard/active_sip_details", { state: { sip_Id } });
  //   };

  return (
    <React.Fragment>
      <Container>
        <Row id="filterRow">
          <span id="filterLogo">
            <div className="d-flex justify-content-between">
              <div onClick={() => toggleFilter()}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
            </div>
            <div className="align-content-center">
              Total Installments :{" "}
              {unpaidInstallment?.totalUnpaidInstallmentsSum}
            </div>
          </span>

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="search"
                  placeholder="Search"
                  value={search.search}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="number"
                  name="installment_amount"
                  placeholder="Search By Installment"
                  value={search.installment_amount}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name=""
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <div>
              <button className="save filter" onClick={Addfilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>
        <div id="directIncomeDiv">
          <Row id="directTableRow" className="">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                <table>
                  <tr>
                    <th style={{ textAlign: "center" }}>S No.</th>
                    <th
                      style={{ textAlign: "center" /*, cursor: "pointer" */ }}
                      // onClick={() => handleSort("name")}
                    >
                      Name{" "}
                      {/* {sortField === "name" &&
                        (sortOrder === "asc" ? "↑" : "↓")} */}
                    </th>
                    <th style={{ textAlign: "center" }}>Username</th>
                    <th style={{ textAlign: "center" }}>SIP Id</th>
                    <th style={{ textAlign: "center" }}>Installment Amount</th>
                    <th style={{ textAlign: "center" }}>Installment Id</th>
                    <th
                      style={{ textAlign: "center" /*, cursor: "pointer" */ }}
                      // onClick={() => handleSort("installment_Date")}
                    >
                      Installment date{" "}
                      {/* {sortField === "installment_Date" &&
                        (sortOrder === "asc" ? "↑" : "↓")} */}
                    </th>
                  </tr>
                  {unpaidInstallment?.data?.map((x, i) => {
                    return x?.unpaidInstallments?.map((installment, j) => (
                      <tr key={`${i}-${j}`}>
                        <td style={{ textAlign: "center" }}>
                          {i + 1 + limitFilter * (currentPage - 1)}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {installment?.name}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {installment?.username}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {installment?.sip_Id}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {installment?.installment_amount}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {installment?.installment_id}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {moment(installment?.installment_Date).format(
                            "MM-DD-YYYY & HH:mm"
                          )}
                        </td>
                      </tr>
                    ));
                  })}
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default UpcomingInstallment;
